module.exports = __webpack_public_path__ + "img/hr-level3addon_mining_hands_shadow.6d32de10.png";